<template>
  <div class="main">
    <div class="add_form">
      <div class="line">
        <div class="title"><span class="Required">*</span>用户名：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="username"
          maxlength="11"
          type="number"
          oninput="if(value.length>11)value=value.slice(0,11)"
        ></el-input>
      </div>
      <div class="line">
        <div class="title"><span class="Required">*</span>密码：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="password"
          maxlength="20"
        ></el-input>
      </div>
      <div class="line">
        <div class="title"><span class="Required">*</span>联系人：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="person_name"
          maxlength="4"
        ></el-input>
      </div>
      <div class="line">
        <div class="title"><span class="Required">*</span>手机号：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="person_phone"
          maxlength="11"
          minlength="11"
        ></el-input>
      </div>

      <div class="line">
        <div class="title">销售人员名字：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="sales_personnel"
          maxlength="4"
        ></el-input>
      </div>

      <div class="line">
        <div class="title">销售手机号码：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="sales_personnel_mobile"
          maxlength="11"
        ></el-input>
      </div>

      <div class="line">
        <div class="title"><span class="Required">*</span>营业执照名称：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="company_name"
          maxlength="200"
        ></el-input>
      </div>
      <div class="line">
        <div class="title">营业执照地址：</div>
        <el-input
          class="input"
          placeholder="请输入内容"
          v-model="company_place"
          maxlength="200"
        ></el-input>
      </div>

      <div class="line">
        <div class="title"><span class="Required">*</span>营业执照：</div>
        <el-upload
          class="avatar-uploader"
          :action="url_Api + '/hr24_user/v1/upload_file/'"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>

    <div class="add_form">
      <div class="line">
        <div class="title">是否充值用户：</div>
        <div class="switch">
          <el-switch
            v-model="is_seed"
            active-text="充值用户"
            inactive-text="非充值用户"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">是否体验用户：</div>
        <div class="switch">
          <el-switch
            v-model="is_experience"
            active-text="体验"
            inactive-text="非体验"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">是否零工用户：</div>
        <div class="switch">
          <el-switch
            v-model="odd_job"
            active-text="零工"
            inactive-text="非零工"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">是否是代理商：</div>
        <div class="switch">
          <el-switch
            v-model="is_agent"
            active-text="代理商"
            inactive-text="非代理商"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">是否是热线帐号：</div>
        <div class="switch">
          <el-switch
            v-model="is_hotline"
            active-text="热线帐号"
            inactive-text="非热线帐号"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">是否是省代：</div>
        <div class="switch">
          <el-switch
            v-model="is_agentS"
            active-text="省代"
            inactive-text="非省代"
          ></el-switch>
        </div>
      </div>
      <div class="line">
        <div class="title">开通权限：</div>
        <div class="switch jurisdiction">
          <el-radio-group v-model="opening_mode" @change="bbb">
            <el-radio :label="0">微信</el-radio>
            <el-radio :label="1">微信+抖音</el-radio>
            <el-radio :label="2">微信+快手</el-radio>
            <el-radio :label="3">微信+抖音+快手</el-radio>
          </el-radio-group>

          <!-- <el-switch
            v-model="opening_mode"
            active-text="微信和抖音"
            inactive-text="微信"
          ></el-switch> -->
        </div>
      </div>

      <div class="line">
        <div class="title"><span class="Required">*</span>用户所在地区：</div>
        <el-cascader
          class="input"
          v-model="place_value"
          :options="place_data"
        ></el-cascader>
      </div>

      <div class="line">
        <div class="title"><span class="Required">*</span>用户所在行业：</div>
        <el-cascader
          class="input"
          v-model="industry_value"
          :options="industry_data"
          :props="{ value: 'industry_id', label: 'name' }"
        ></el-cascader>
      </div>

      <div class="line" style="width: 700px">
        <div class="title"><span class="Required">*</span>直销、代理商：</div>
        <el-cascader
          class="input"
          v-model="agent_value"
          :options="agent_data"
        ></el-cascader>
        <span style="display: inline" v-if="city_agent_person_name">
          <el-tooltip
            :content="'代理商提示：' + city_agent_person_name"
            v-model="aaa"
            placement="top"
          >
            <div class="aa">?</div>
          </el-tooltip>
        </span>
      </div>

      <div class="line">
        <div class="title"><span class="Required">*</span>会员开通时间：</div>
        <el-date-picker
          v-model="vip_time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        ></el-date-picker>
      </div>
    </div>
    <div class="button">
      <el-row>
        <el-button type="primary" @click="create_user" :loading="is_loading"
          >确认开通</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { require, url_Api } from "@/utils/http_request.js";

export default {
  data() {
    return {
      aaa: true,
      is_loading: false,
      is_agentS: false,
      username: "",
      password: "",
      person_name: "",
      person_phone: "",
      company_name: "",
      company_place: "",
      place_data: [],
      place_value: [],
      imageUrl: "",
      license: "",
      is_seed: false,
      is_experience: false,
      odd_job: false,
      is_agent: false,
      is_hotline: false,
      opening_mode: 0,
      industry_data: [],
      industry_value: [],
      agent_data: [],
      agent_value: [],
      vip_time: "",
      sales_personnel: "",
      sales_personnel_mobile: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      hr24_open_account: "",
      url_Api: "",
      city_agent_person_name: "",
    };
  },
  created() {
    //is_add:0  为没有不限  或者为有不限
    require("post", "/commonality/v1/show_place_json/", { is_add: 0 }).then(
      (res) => {
        console.log(res);
        if (res.code == 0) {
          this.place_data = res.data;
        }
      }
    );
    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
    this.show_agent_city();
    this.create_hao();
    // axios.get("/static/json/agent.json").then(res => {
    //   this.agent_data = res;
    // });
    this.url_Api = url_Api;
  },

  place_change(e) {
    console.log(e);
  },

  methods: {
    bbb(){
      console.log(this.opening_mode)
    },
    create_hao() {
      console.log(this.$route.params.id);
      if (this.$route.params.id) {
        let data = JSON.parse(this.$route.params.id);
        console.log("dairu de shuju ", data);
        this.city_agent_person_name = data.city_agent_person_name;
        this.username = data.opened_account;
        this.password = data.opened_account;
        this.person_name = data.client_name;
        this.person_phone = data.client_phone;
        this.sales_personnel = data.sale_people_name;
        this.company_name = data.company_name;
        this.industry_value = data.industry_id;
        this.imageUrl = data.business_license_img[0];
        this.license = data.business_license_img_id;
        this.place_value = [
          data.place_name.province_code,
          data.place_name.city_code,
          data.place_name.district_code,
        ];
        this.company_place =
          data.place_name.province_name ||
          "" + data.place_name.city_name ||
          "" + data.place_name.district_name ||
          "";
        console.log(this.place_value);
        this.hr24_open_account = data.hr24_open_account;
      }
    },
    // 开通用户
    show_agent_city() {
      console.log("大使");
      require("post", "/hr24_user/v1/show_agent_city/", {}).then((res) => {
        console.log("res", res);
        this.agent_data = res.data;
      });
    },
    create_user() {
      this.is_loading = true;
      this.is_experience = this.is_experience ? 1 : 0;
      this.is_seed = this.is_seed ? 1 : 0;
      this.odd_job = this.odd_job ? 1 : 0;
      this.is_agent = this.is_agent ? 1 : 0;
      this.is_hotline = this.is_hotline ? 1 : 1;
      this.is_agent = this.is_agentS ? 2 : ( this.is_agent ? 1 : 0 )


      // 三个开关
      // if (this.is_experience) {
      //   this.is_experience = 1;
      // } else {
      //   this.is_experience = 0;
      // }
      // if (this.opening_mode) {
      //   this.opening_mode = 1;
      // } else {
      //   this.opening_mode = 0;
      // }

      // if (this.is_seed) {
      //   this.is_seed = 1;
      // } else {
      //   this.is_seed = 0;
      // }

      // if (this.odd_job) {
      //   this.odd_job = 1;
      // } else {
      //   this.odd_job = 0;
      // }

      // if (this.is_agent) {
      //   this.is_agent = 1;
      // } else {
      //   this.is_agent = 0;
      // }
      // if (this.is_hotline) {
      //   this.is_hotline = 1;
      // } else {
      //   this.is_hotline = 0;
      // }
      // if (this.is_agentS) {
      //   this.is_agent = 2;
      // } else {
      //   if (this.is_agent) {
      //     this.is_agent = 1;
      //   } else {
      //     this.is_agent = 0;
      //   }
      // }

      // console.log(
      //   "ex",
      //   this.is_experience,
      //   "seed",
      //   this.is_seed,
      //   "test",
      //   this.odd_job,
      //   "agent",
      //   this.is_agent,
      //   "is_hotline",
      //   this.is_hotline,
      //   " this.opening_mode",
      //   this.opening_mode
      // );
      console.log('this.username', this.username)
      if (this.username.length != 11) {
        this.$message.error("用户名不是11位或不是纯数字！");
        this.is_loading = false;
        return;
      }

      if (this.password.length < 6) {
        this.$message.error("密码长度最少也要6位哦");
        this.is_loading = false;
        return;
      }

      if (this.person_name.length < 1) {
        this.$message.error("联系人还没有填呢");
        this.is_loading = false;
        return;
      }

      if (this.person_phone.length != 11) {
        this.$message.error("手机号长度要11位哦");
        this.is_loading = false;
        return;
      }
      if(!this.company_name){
        this.$message.error("请填写营业执照名称");
        this.is_loading = false;
        return;
      }
      if(!this.imageUrl){
        this.$message.error("请上传营业执照图片");
        this.is_loading = false;
        return;
      }

      console.log(this.place_value, this.industry_value, this.agent_value);
      if (this.place_value.length == 0) {
        this.$message.error("地区还没有选呢");
        this.is_loading = false;
        return;
      }

      if (this.industry_value.length == 0) {
        this.$message.error("行业还没有选呢");
        this.is_loading = false;
        return;
      }

      if (this.agent_value.length == 0) {
        this.$message.error("直销、代理商还没有选呢");
        this.is_loading = false;
        return;
      }

      if (this.vip_time.length == 0) {
        this.$message.error("会员时间还没选呢呀");
        this.is_loading = false;
        return;
      } else {
        this.vip_start_time = Number(
          this.vip_time[0].getTime(this.vip_time[0]) / 1000
        );

        console.log(this.vip_start_time);
        this.vip_end_time = Number(
          this.vip_time[1].getTime(this.vip_time[1]) / 1000
        );
        console.log(this.vip_end_time);
      }

      let obj = {
        username: this.username,
        password: this.password,
        contact_name: this.person_name,
        contact_phone: this.person_phone,
        is_seed: this.is_seed,

        province_id: Number(this.place_value[0]),
        city_id: Number(this.place_value[1]),
        district_id: Number(this.place_value[2]),

        vip_start_time: this.vip_start_time,
        vip_end_time: this.vip_end_time,

        is_experience: this.is_experience,
        is_hotline: this.is_hotline,

        industry_id: this.industry_value[1],
        license: this.license,
        odd_job: this.odd_job,
        is_agent: this.is_agent,
        license_company_name: this.company_name,
        license_company_place: this.company_place,

        sales_personnel: this.sales_personnel,
        sales_personnel_mobile: this.sales_personnel_mobile,

        agent_id: this.agent_value[this.agent_value.length - 1],
        account_access: this.opening_mode,
      };

      console.log(obj);
      obj = { insert_data: obj };
      if (this.hr24_open_account) {
        obj.hr24_open_account = this.hr24_open_account + "";
      }

      require("post", "/hr24_user/v1/lufish_user_reg/", obj).then((res) => {
        if (!res.code) {
          this.$message({
            message: "注册账户成功，请不要重复提交",
            type: "success",
          });
          // 隐藏加载，跳转到首页
          this.show_agent_city();
          this.is_loading = false;
          this.chushihua();
        } else {
          this.$message.error(res.msg);
          this.is_loading = false;
        }
      });
    },
    //初始化
    chushihua() {
      this.username = "";
      this.password = "";
      this.is_experience = false;
      this.sales_personnel = "";
      this.is_seed = false;
      this.odd_job = false;
      this.is_agent = false;
      this.is_agentS = false;
      this.person_name = "";
      this.person_phone = "";
      this.company_name = "";
      this.company_place = "";
      this.industry_value = "";
      this.agent_value = "";
      this.place_value = [];
      this.imageUrl = "";
      this.license = "";
      this.vip_time = "";
      this.sales_personnel_mobile = "";
    },
    handleAvatarSuccess(res, file) {
      // 图片参数
      console.log(res, file);
      this.license = res.data.file_data.file_id;
      // 展示图片变量
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;

      //   if (!isJPG) {
      //     this.$message.error("上传头像图片只能是 JPG 格式!");
      //   }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt10M;
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.main {
  width: 1200px;
  margin: 60px auto;
}
.el-button--mini,
.el-button--small {
  font-size: 14px;
  width: 220px;
  height: 50px;
  border-radius: 3px;
}

.el-input--small .el-input__inner {
  width: 300px;
  height: 40px;
}

.el-range-editor--small .el-range-separator {
  line-height: 32px;
  font-size: 13px;
}

.el-range-editor--small.el-input__inner {
  /* height: 32px; */
  width: 430px;
}

.el-input--small .el-input__inner {
  padding-left: 24px;
}
.el-switch__label {
  font-size: 18px;
}

.switch {
  padding-left: 20px;
  padding-top: 6px;
  margin-bottom: 40px;
}

.sm_main {
  display: flex;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  position: relative;
  /* padding-top: 100px; */
  top: 0px;
  border: 1px solid rgb(145, 145, 145);
}

.el-input--small .el-input__inner {
  height: 30px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-cascader {
  width: 250px;
}

.add_form {
  /* border: 1px solid #ccc; */
  width: 500px;
  /* height: 1000px; */
  /* padding: 50px; */
  font-size: 18px;
  float: left;
  /* margin-right: 80px; */
}

.input {
  width: 360px;
  margin-bottom: 30px;
}
.title {
  width: 150px;
  line-height: 40px;
  text-align: right;
}

.line {
  display: flex;
  font-size: 14px;
}

.button {
  /* background: red; */
  /* margin-top: 120px; */
  /* width: 500px; */
  clear: both;
  height: 100px;
  text-align: center;
  padding-top: 100px;
}
.aa {
  width: 21px;
  text-align: center;
  line-height: 21px;
  margin: 9px;
  color: rgb(255, 255, 255);
  border-radius: 50%;
  cursor: pointer;
  background: #000;
}

.jurisdiction .el-radio{
  width: 50% !important;
  margin-right: 0 !important;
  line-height: 20px;
}
.Required{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/user_management/add_user.vue